export const isMobile = () => /iphone|ipod|android|ie|blackberry|fennec/i.test(navigator.userAgent);

export const isString = value => typeof value === 'string';

export const isAlphaNum = value => /^(?=.*[a-zA-Z])[a-zA-Z0-9\s]+$/.test(value)